export default __webpack_public_path__ + "static/media/ProfilePicture.a98c375f.png";